import themes from 'devextreme/ui/themes';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

import { licenseKey } from './devextreme-license';
import config from 'devextreme/core/config';




themes.initialized(() => {
  config({ licenseKey });
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
});
